import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { Avatar, UserAvatar } from '../../common/Avatar'
import { NotificationData } from '../../../types/notifications'
import { societyQueries } from '../../../api/societies'
import { userQueries } from '../../../api/users'
import { INotificationModel } from '../../../interfaces/models/notifications.interfaces'

interface NotificationAvatarProps {
  notification: INotificationModel
  notificationData: NotificationData | undefined
}

export const NotificationAvatar = ({
  notification,
  notificationData,
}: NotificationAvatarProps): React.ReactNode => {
  const notificationFromUser = notificationData && notificationData.from
  const notificationSociety = notificationData && notificationData.society
  const notificationRoom = notificationData && notificationData.room

  const { data: society } = useQuery(
    societyQueries.getSociety(notificationRoom?.societyId)
  )
  const { data: _society } = useQuery(
    societyQueries.getSociety(notification?.societyId)
  )
  const { data: user } = useQuery(
    userQueries.getUser(notificationFromUser?._id)
  )

  let media

  if (notificationSociety) {
    media = notificationSociety.coverPhotoId
  } else if (notificationRoom) {
    media = society?.coverPhotoId
  } else if (notification.societyId) {
    media = _society?.coverPhotoId
  }

  if (
    notification.type === 'invite-all-to-society' &&
    notificationSociety?.coverPhotoId
  ) {
    return <Avatar mediaId={notificationSociety.coverPhotoId} />
  }
  if (
    notification.type === 'new-ticket-from-board' &&
    notificationSociety?.coverPhotoId
  ) {
    return <Avatar mediaId={notificationSociety.coverPhotoId} />
  }

  return notificationFromUser ? (
    <UserAvatar user={user} />
  ) : (
    <Avatar mediaId={media} />
  )
}
